import type { TourResponse } from '../../../src/store/facade/facadeApiV3';
import {
    ChargingStopWaypointSettingsType,
    Currency,
    EngineType,
    PlugType,
    TourEventType,
    TourStatus,
    TunnelCategory,
    VehicleType,
    WaypointType,
} from '../../../src/store/facade/facadeApiV3';

export const tourIdList = [
    '5a3e778e-67cc-43d5-9021-e0c7659a6dbe',
    'ddcdffec-9666-4c39-ba8e-f66505fa3207',
    '95c90bfb-9983-43a5-b0e5-2c462744c260',
];

export const tourMock: TourResponse = {
    tourId: 'ddcdffec-9666-4c39-ba8e-f66505fa3207',
    revision: 1,
    name: 'Test Tour',
    status: TourStatus.Draft,
    departure: {
        coordinates: {
            latitude: 38.72633,
            longitude: -9.14952,
        },
        name: 'Praça de Almeida Garrett 49, 4000-069 Porto, Portugal',
        address: {
            street: 'Praça de Almeida Garrett',
            number: '49',
            city: 'Porto',
            region: 'Porto',
            countryCode: 'PRT',
            postalCode: '4000-069',
        },
        desiredDepartureTime: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(),
        initialCargoWeight: 500,
    },
    arrival: {
        coordinates: {
            latitude: 41.14584,
            longitude: -8.610815,
        },
        name: 'Avenida Fontes Pereira de Melo',
        address: {
            street: 'Avenida Fontes Pereira de Melo',
            number: '',
            city: 'Lisboa',
            region: 'Lisboa',
            countryCode: 'PRT',
            postalCode: '1050-115',
        },
    },
    waypoints: [
        {
            waypointId: 231274712,
            coordinates: { latitude: 39.5467, longitude: -8.9865 },
            waypointType: WaypointType.Stopover,
            name: 'Coimbra',
            address: { city: 'Coimbra', street: 'Rua Example', countryCode: 'PRT', postalCode: '3000-001' },
            duration: 80,
            weightDelta: 200,
        },
        {
            waypointId: 1093232,
            coordinates: { latitude: 40.3435, longitude: -8.5968 },
            waypointType: WaypointType.ChargingStop,
            stationId: 'station-54321',
            name: 'Charging Station Name',
            address: { city: 'Cidade', street: 'Rua da Estacao', countryCode: 'PRT', postalCode: '1234-567' },
            settings: {
                chargingStopWaypointSettingsType: ChargingStopWaypointSettingsType.Duration,
                minDuration: 30,
                maxDuration: 120,
            },
        },
    ],
    vehicle: {
        engineType: EngineType.Electric,
        vehicleType: VehicleType.Truck,
        length: 12,
        width: 2.5,
        height: 4,
        emptyWeight: 8000,
        trailerCount: 0,
        axlesCount: 2,
        trailerAxlesCount: 0,
        maxWeightPerAxle: 10000,
        tunnelCategory: TunnelCategory.All,
        plugType: [PlugType.CcsCombo1, PlugType.CcsCombo2],
        evSettings: {
            initialBatteryCapacity: 80,
        },
        vehicleId: '6da2b1b1-b714-4af7-9c57-c81b8dc3519a',
    },
    constraints: {
        features: [],
        hazardous_classes: [],
    },
    costSettings: {
        currency: Currency.Eur,
        vehiclePerKm: 0,
        energyPerKwh: 0,
    },
    createAt: '2021-01-30T08:30:00Z',
    lastUpdate: '2021-01-30T08:30:00Z',
    isAutomated: false,
    // CVI-17360: SRP-originated tour with expired departure time — triggers blocking dialog
    events: {
        timelineEvents: [
            {
                eventId: 'evt-001',
                occurredAt: '2021-01-30T08:30:00Z',
                tourEventType: TourEventType.Created,
                requestedByVehicle: false, // SRP-originated (dispatcher-created)
            },
        ],
    },
};
